import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    uploadDescription: 'or drag and drop',
    uploadFailureMessage:
      'Upload failed. Please check your connection and try again',
    uploading: 'Uploading...',
    uploadTitle: {
      regular: `Add your document`,
      touch: 'Touch here to upload your document',
    },
  },
  fr: {
    uploadDescription: 'ou glisser déposer',
    uploadFailureMessage:
      'Le téléchargement a échoué. Veuillez vérifier votre connexion et réessayer.',
    uploading: 'En cours de téléchargement...',
    uploadTitle: {
      regular: 'Ajoutez votre document',
      touch: 'Touchez ici pour télécharger votre document',
    },
  },
} as const);

export default locales;
